/**
 * A copied list group → one of this country's shared list groups, the same
 * group created here (same name, its rule as this country reads it — v2:
 * a hand-picked group with each list's twin, the row says how many came),
 * or Leave out.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { GROUP_COPY_CREATE, type GroupCopyListGroupRow } from '@trafficpulse/shared';

import { SearchableSelect, type SearchableSelectOption } from '@/components/ui';
import { GroupChip } from '@/features/drop-generator/components/shared/GroupChip';

import { matchBadge } from '../MatchBadge';
import { PickRow, usedByLine } from '../PickRow';
import { LEAVE_OUT } from './GatewayPick';

interface Props {
  row: GroupCopyListGroupRow;
  options: Array<{ id: string; name: string; color: string }>;
  answered: boolean;
  onPick: (target: string | null) => void;
  /** In a fold: one line (27/10/2026). */
  compact?: boolean;
}

function listGroupOptions(row: GroupCopyListGroupRow, options: Props['options']): SearchableSelectOption<string>[] {
  const groups = options.map((o) => {
    const chip = <GroupChip name={o.name} color={o.color} />;
    return { value: o.id, label: o.name, optionContent: chip, triggerContent: chip };
  });
  const create = [{ value: GROUP_COPY_CREATE, label: `Create “${row.name}” here` }];
  return [...groups, ...create, { value: LEAVE_OUT, label: 'Leave out' }];
}

export const ListGroupPick: FC<Props> = ({ row, options, answered, onPick, compact }) => {
  const value = row.target ?? (answered || row.how !== 'none' ? LEAVE_OUT : '');
  const meta = `${usedByLine(row.usedBy)}${row.lists ? ` · ${row.lists.matched} of ${row.lists.total} hand-picked lists found here` : ''}`;
  return (
    <PickRow
      compact={compact}
      name={row.name}
      source={<GroupChip name={row.name} color={row.color} />}
      select={<SearchableSelect options={listGroupOptions(row, options)} value={value} onChange={(v) => onPick(v === LEAVE_OUT ? null : v)} placeholder="Pick a list group…" searchPlaceholder="Search a list group…" className="h-8" />}
      badge={matchBadge(row.how, row.target !== null, answered)}
      meta={meta}
    />
  );
};
